import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/coupon-notice-img.png'


const _hoisted_1 = { class: "coupons" }
const _hoisted_2 = { class: "sizing" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"top\"><div class=\"image\"><img src=\"" + _imports_0 + "\" alt=\"\"></div><div class=\"text\"><div class=\"caption\">オフィシャルファンクラブ「LOCALS ONLY」</div><div class=\"title\">来場者特典</div></div></div>", 1)
const _hoisted_4 = { class: "coupon" }
const _hoisted_5 = { class: "drink" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, [
  /*#__PURE__*/_createTextVNode("OFFICIAL MERCHANDISE "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ¥500OFFクーポン")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "caption" }, [
  /*#__PURE__*/_createTextVNode(" 有料会員のお客様限定で"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("物販ブースでツアー期間中1回使用可能"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("クーポンを配布いたします。 ")
], -1)
const _hoisted_8 = {
  key: 0,
  class: "link",
  href: "#/drink_coupon"
}
const _hoisted_9 = {
  key: 1,
  class: "link-disabled",
  href: "#"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          (_ctx.isPremiumMember)
            ? (_openBlock(), _createElementBlock("a", _hoisted_8, "プレゼントはこちら"))
            : (_openBlock(), _createElementBlock("a", _hoisted_9, "クーポンはこちら"))
        ])
      ])
    ])
  ]))
}